module.exports = __webpack_public_path__ + "static/media/red-oval.d8d8a901.svg";